import { toSnake, toCamel } from 'change-object-case'
import { deserializer, client } from 'services/client'
import queryString from 'query-string'
import { irwin } from 'config'

async function getUserUploads(params) {
  const response = await client().get('v2/user_upload_requests', {
    params: toSnake(params),
  })

  return {
    data: deserializer.deserialize(response),
    meta: toCamel(response.meta, { recursive: true, arrayRecursive: true }),
  }
}

function getUserUploadsExportURL(params) {
  const formattedParams = toSnake(params)
  const queryParams = queryString.stringify(formattedParams, { arrayFormat: 'bracket' })
  return `v2/user_upload_requests.csv?${queryParams}`
}

async function createUserUploadRequest(params) {
  const response = await client().post(
    'v2/user_upload_requests',
    toSnake({ ...params, notifyUpload: false }), // notifyUpload is used to prevent email notifications during creation
  )

  return {
    data: deserializer.deserialize(response),
  }
}

async function updateUserUploads(id, params) {
  const response = await client().patch(`v2/user_upload_requests/${id}`, toSnake(params))

  return {
    data: deserializer.deserialize(response),
  }
}

async function getUserResourceLink(id, filePath) {
  const response = await client().get(`v2/user_upload_requests/${id}/download`, {
    params: { file_path: toSnake(filePath) },
  })

  return toCamel(response, { recursive: true })
}

async function deleteUserUploadRequest(id) {
  const response = await client().delete(`v2/user_upload_requests/${id}`)
  return deserializer.deserialize(response)
}

function getBulkDownloadUrl(id) {
  const url = `${irwin.baseUrl}/v2/user_upload_requests/${id}/bulk_download`

  return url
}

export {
  getUserUploads,
  updateUserUploads,
  getUserResourceLink,
  deleteUserUploadRequest,
  getUserUploadsExportURL,
  createUserUploadRequest,
  getBulkDownloadUrl,
}
